export * from './AssortmentPDFTemplate'


// WEBPACK FOOTER //
// ./src/modules/pdf/serverRenderedPDF/templates/assortment/index.ts